// Put stuff in here that is widely used across the site.
//
// Features that are used only on a few pages, such as most
// view components, should be imported into individual packs.

import {
  PlatformAdminUI,
  RandomProjectHotkey,
  gaScrollTracking,
} from '../utils'

document.addEventListener("DOMContentLoaded", () => {
  new PlatformAdminUI()
  new RandomProjectHotkey()
})

document.addEventListener('scroll', gaScrollTracking)
